import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-header p-d-flex" }
const _hoisted_2 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "metaweb-select-dialog",
    class: "metaweb-dialog remove-padding p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.metawebSelectDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: false,
    closable: false,
    position: "right",
    baseZIndex: 1,
    autoZIndex: true
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.businessModel?.name), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "metaweb-select-dialog-button kn-button p-button-text p-m-2",
            label: _ctx.$t('common.close'),
            onClick: _ctx.closeDialog
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            class: "metaweb-select-dialog-button kn-button p-button-text",
            label: _ctx.$t('common.continue'),
            onClick: _ctx.onContinue
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            value: _ctx.rows,
            class: "p-datatable-sm kn-table p-ml-1",
            scrollable: true,
            scrollHeight: "100%",
            filters: _ctx.filters,
            "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters = $event)),
            globalFilterFields: _ctx.metawebSelectDialogDescriptor.globalFilterFields,
            onFilter: _ctx.onRowsFiltered
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            header: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("span", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.filters['global'].value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                    placeholder: _ctx.$t('common.search')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "value",
                header: _ctx.$t('metaweb.selectDialog.tableName'),
                style: {"flex":"5"}
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                header: _ctx.$t('metaweb.physicalModel.title')
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_Checkbox, {
                    class: "p-mr-2",
                    modelValue: _ctx.allPhysicalSelected,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.allPhysicalSelected = $event)),
                    binary: true,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAllChecked('physical')))
                  }, null, 8, ["modelValue"])
                ]),
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selected[slotProps.data.value].physical,
                    "onUpdate:modelValue": ($event: any) => (_ctx.selected[slotProps.data.value].physical = $event),
                    binary: true,
                    onChange: ($event: any) => (_ctx.setChecked(slotProps.data, 'physical'))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: _ctx.$t('metaweb.businessModel.title')
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_Checkbox, {
                    class: "p-mr-2",
                    modelValue: _ctx.allBusinessSelected,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.allBusinessSelected = $event)),
                    binary: true,
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setAllChecked('business')))
                  }, null, 8, ["modelValue"])
                ]),
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selected[slotProps.data.value].business,
                    "onUpdate:modelValue": ($event: any) => (_ctx.selected[slotProps.data.value].business = $event),
                    binary: true,
                    onChange: ($event: any) => (_ctx.setChecked(slotProps.data, 'business'))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value", "filters", "globalFilterFields", "onFilter"]))
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}